import { OnDestroy, Component, OnInit, Optional, Inject } from '@angular/core';
import { PershingTranslationService, LogService, ServiceRouter, IStorageService } from '@pershing/pershing-core';
import { MatDialogRef } from '@angular/material/dialog';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NXIRestServiceDefinition } from '../../services/NXI-Rest-service-definition';
@Component({
    selector: 'login-review-dialog',
    templateUrl: './login-review-dialog.html'
})
export class LoginReviewDialogComponent implements OnInit, OnDestroy {
    community: string;
    ibdName: string;
    secondsLeft: number = 10;
    interval;
    private serviceUrl: string;
    brandedurl: any;
    private validSession = false;
    constructor(
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any, private dialogRef: MatDialogRef<LoginReviewDialogComponent>,
        private logService: LogService, private nxiRestService: NxiRestService,
        private http: HttpClient, private serviceRouter: ServiceRouter,
        private storageService: IStorageService ) {
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.community = parsemap.community;
            this.ibdName = parsemap.ibdName;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }
    startTimer() {
        this.logService.info('timer starting in popup');
        this.interval = setInterval(() => {
            if (this.secondsLeft > 0) {
                this.secondsLeft--;
            } else {
                this.endSession();
            }
        }, 1000);
    }
    endSession() {
        this.logService.info('logout session');
        this.logout('timedOut');
    }
    cancelDialog() {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        // this.closeDialog();
    }
    ngOnInit() {
        this.startTimer();
        this.getBrandedURL();
    }
    redirectTheUser () {
         this.logout('timedOut');
    }
   logout(message?: string): void {
        this.logService.info('Invoking Logout');
        this.resetLocalStorage();
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        let params = new HttpParams();
        if (message) {
            params = params.append('message', message);
        } else {
            params = params.append('message', '');
        }
        this.http.get(this.serviceUrl + '/session/logout', { params, responseType: 'json' })
            .subscribe(data => {
                console.log('logout Url is ' + data);
                if (message) {
                        location.href = this.brandedurl + '/nxi/login';
                } else {
                    location.href = this.brandedurl + '/nxi/login';
                }
            }, err => {
                location.href = this.brandedurl + '/nxi/login';
            });
    }

    getBrandedURL(): void {
        this.nxiRestService.getBrandedURL().subscribe(
            (resp) => {
               this.brandedurl = resp;
            }
        );
    }
    resetLocalStorage() {
        this.validSession = false;
        if (localStorage.getItem('token')) {
            localStorage.removeItem('token');
        }
        // for nxp login - will be removed
        if (localStorage.getItem('cookie')) {
            localStorage.removeItem('cookie');
        }
        sessionStorage.removeItem('nav_current_pageid');
        sessionStorage.removeItem('realTimeActive');
        if (sessionStorage.getItem('vendorKeepAliveUrl')) {
            sessionStorage.removeItem('vendorKeepAliveUrl');
        }
        if (this.storageService.getItem('nxiSelectedAccountValue')) {
            this.storageService.removeItem('nxiSelectedAccountValue');
        }
        if (sessionStorage.getItem('isThemeSelectionPopupShown')) {
            sessionStorage.removeItem('isThemeSelectionPopupShown');
        }
        if (sessionStorage.getItem('isGABannerClosedByUser')) {
            sessionStorage.removeItem('isGABannerClosedByUser');
        }
    }

}
